import { InputNumerico } from "app/components/inputs/InputNumerico";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React, { memo, useCallback, useMemo } from "react";
const estiloRegistrarPerdaCotacao = require("./registrarPerdaCotacao.module.scss").default;
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosTabela = require('../../../estilos/tabelas.module.scss').default

export type ListaMotivos = {
    Codigo: string
    Nome: string
    DescricaoCombo: string
    UserMessage?: string,
    Transforming: boolean
}

export type ListaConcorrentes = {
    Codigo: number,
    Nome: string
    UserMessage?: string,
    Transforming: boolean
}

export type CotacoesPerdidasPorOrcamento = {
    NomeCliente?: string
    CPFCNPJ?: string
    CodigoProduto?: string,
    DescricaoProduto?: string,
    Quantidade?: number
    PrecoVenda?: number
    CodigoConcorrente?: number
    PrecoConcorrente?: number
    CodigoMotivo?: string,
    Observacao?: string,
    PerdaCotacao?: PerdaCotacao[],
    UserMessage?: string,
    Transforming?: boolean
}

export type PerdaCotacao = {
    Codigo: number,
    CodigoFilial: number,
    NumeroPedido: number,
    CodigoCliente: number,
    DataMovimentacao: string,
    Quantidade: number,
    CodigoMotivo: string,
    DescricaoMotivo: string,
    NomeConcorrente: string,
    CodigoConcorrente: number,
    PrecoConcorrente: number,
    PrecoVenda: number,
    Moeda: number,
    Observacao: string,
    CodigoVendedor: string,
    ICMS: number,
    CodigoProduto?: string,
    DescricaoProduto?: string,
    CodigoProdutoExibicao: string,
    DescricaoProdutoExibicao: string,
    UserMessage?: string,
    Transforming: boolean
}

export type RegistroPerdaCotacao = {
    CPFCNPJ: string
    CodigoConcorrente: number
    CodigoMotivo?: string
    CodigoProduto?: string
    DescricaoProduto?: string
    ItenSelecionados: number[]
    ManterItem: boolean
    NomeCliente: string
    Observacao?: string
    PerdaCotacao?: PerdaCotacao[]
    PrecoConcorrente: number
    PrecoVenda: number
    Quantidade: number
    Transforming: boolean
    UserMessage?: string
}

export type DadosRegistroPerdaCotacao = {
    Quantidade:number
    CodigoConcorrente:number
    PrecoConcorrente: number
    CodigoMotivo:number
    Observacao:string
    PerdaCotacaoTodosItens: boolean // 470698
}

export type RegistrarPerdaCotacaoProps = {
    perdaTotal?: boolean // 470698
    cotacoesPerdidasPorOrcamento: CotacoesPerdidasPorOrcamento
    listaMotivos: ListaMotivos[]
    listarConcorrentes: ListaConcorrentes[]
    onRegistrar: (registroPerdaCotacao: DadosRegistroPerdaCotacao, materItemNoOrcamento: boolean) => void
    identificadorItem?:number
    manterItem: boolean,
    quantidadeProduto: number
    processando?: boolean
}


export const RegistrarPerdaCotacao = memo((props: RegistrarPerdaCotacaoProps) => { // atenção no editar itens, se o parametro ACEITAR_PRODUTO_SEM_ESTOQUE != S é possivel gerar cotacao perdida por lá

    const formik = useFormik<DadosRegistroPerdaCotacao>({
        initialValues: {
            Quantidade: props.quantidadeProduto,
            CodigoConcorrente: null,
            PrecoConcorrente: 0,
            CodigoMotivo: null,
            Observacao: "",
            PerdaCotacaoTodosItens: props.perdaTotal ?? false // 470698
        },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });

    const onQuantidadeModificada = useCallback((valor: number) => {
        formik.setFieldValue("Quantidade", valor);
    }, [formik.setFieldValue])

    const onPrecoConcorrenteModificado = useCallback((valor: number) => {
        formik.setFieldValue("PrecoConcorrente", valor);
    }, [formik.setFieldValue])

    const opcoesConcorrentes = useMemo(() => (
        props.listarConcorrentes?.map((value) => (
            <option key={value.Codigo} value={value.Codigo}>
                {value.Nome}
            </option>
        ))
    ), [props.listarConcorrentes])

    const opcoesMotivos = useMemo(() => (
        props.listaMotivos?.map((value) => (
            <option key={value.Codigo} value={value.Codigo}>
                {value.Nome}
            </option>
        ))
    ), [props.listaMotivos])

    const linhasCotacoesPerdidas = useMemo(() => (
        props?.cotacoesPerdidasPorOrcamento?.PerdaCotacao?.map((cotacao) => (
            <div key={cotacao.Codigo} className={`_table-row`}
                id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}`}
            >
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-DataMovimentacao`}
                >{globalMU.formatDate(cotacao.DataMovimentacao)}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-Quantidade`} 
                    style={{ textAlign: "right" }}
                >{globalMU.formatarValorNumerico(cotacao.Quantidade, 3, false)}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-DescricaoProduto`}
                >{`${cotacao.CodigoProdutoExibicao} - ${cotacao.DescricaoProdutoExibicao}`}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-PrecoVenda`}
                    style={{ textAlign: "right" }}
                >{globalMU.formatarValorNumerico(cotacao.PrecoVenda, 3, true)}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-PrecoConcorrente`}
                    style={{ textAlign: "right" }}
                >{globalMU.formatarValorNumerico(cotacao.PrecoConcorrente, 3, true)}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-NomeConcorrente`}
                >{cotacao.NomeConcorrente}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-DescricaoMotivo`}
                >{cotacao.DescricaoMotivo}</div>
                <div className={`_table-cell ${estiloRegistrarPerdaCotacao.tableCellBody}`}
                    id={`RegistrarPerdaCotacao_LinhaPerdaCotacao-${cotacao.Codigo}-Observacao`}
                >{cotacao.Observacao}</div>
            </div>
        ))
    ), [props.cotacoesPerdidasPorOrcamento?.PerdaCotacao])

    return (
        <>
            <div>
                <div className={estiloRegistrarPerdaCotacao.legenda}>Cliente</div>
                <div className={estiloRegistrarPerdaCotacao.infoCliente}
                    id="RegistrarPerdaCotacao_InfoCliente"
                >
                    <label>CNPJ / CPF</label>
                    <div
                        id="RegistrarPerdaCotacao_InfoCliente_CPFCNPJ"
                    >{props?.cotacoesPerdidasPorOrcamento?.CPFCNPJ}</div>
                    <label>Nome do Cliente</label>
                    <div
                        id="RegistrarPerdaCotacao_InfoCliente_NomeCliente"
                    >{props?.cotacoesPerdidasPorOrcamento?.NomeCliente}</div>
                </div>

            {props.identificadorItem != null && !props.perdaTotal && <>
                <div className={estiloRegistrarPerdaCotacao.legenda}
                    id="RegistrarPerdaCotacao_InfoProduto"
                >Produto</div>
                <div 
                id="RegistrarPerdaCotacao_InfoProdutos">
                    <div className={estiloRegistrarPerdaCotacao.infoProdutos}>
                        <label>Referência</label>
                        <div
                            id="RegistrarPerdaCotacao_InfoProdutos_CodigoProduto"
                        >{props?.cotacoesPerdidasPorOrcamento?.CodigoProduto}</div>

                        <label>Descrição</label>
                        <div
                            id="RegistrarPerdaCotacao_InfoProdutos_DescricaoProduto"
                        >{props?.cotacoesPerdidasPorOrcamento?.DescricaoProduto}</div>

                    </div>
                    <div className={estiloRegistrarPerdaCotacao.infoProdutos}>
                        <label>Quantidade</label>

                        <InputNumerico
                            id="RegistrarPerdaCotacao_InfoProdutos_Quantidade"
                            onValorModificado={onQuantidadeModificada}
                            numeroCasasDecimais={3}
                            selecionaValorOnFocus={true}
                            campoNullavel={true}
                            valor={formik.values?.Quantidade}
                            disabled={props.processando}
                        />

                        <label>Preço de Venda</label>
                        <div
                            id="RegistrarPerdaCotacao_InfoProdutos_PrecoVenda"
                        >{globalMU.formatarValorNumerico(props?.cotacoesPerdidasPorOrcamento?.PrecoVenda, 2, true)}</div>
                    </div>
                </div>
            </>}

                <div className={estiloRegistrarPerdaCotacao.legenda}>Perda Cotação</div>
                <div className={estiloRegistrarPerdaCotacao.infoPerdaCotacao}>
                    <label>Concorrente</label>
                    <select
                        disabled={props.processando}
                        style={{ maxWidth: "130px" }}
                        value={formik.values?.CodigoConcorrente ?? ''}
                        name="CodigoConcorrente"
                        onChange={formik.handleChange}
                        id="RegistrarPerdaCotacao_Concorrente"
                    >
                        <option value="">Selecione</option>
                        {opcoesConcorrentes}
                    </select>

                    {!props.perdaTotal && <> 
                    <label>Preço Concorrente</label>
                    <InputNumerico
                        onValorModificado={onPrecoConcorrenteModificado}
                        numeroCasasDecimais={3}
                        selecionaValorOnFocus={true}
                        campoNullavel={true}
                        id="RegistrarPerdaCotacao_PrecoConcorrente"
                        valor={formik.values?.PrecoConcorrente}
                        disabled={props.processando}
                    />
                    </>}
                    <label>Motivo</label>
                    <select
                        disabled={props.processando}
                        style={{ maxWidth: "200px" }}
                        value={formik.values?.CodigoMotivo ?? ''}
                        name="CodigoMotivo"
                        onChange={formik.handleChange}
                        id="RegistrarPerdaCotacao_Motivo"
                    >
                        <option value="">Selecione</option>
                        {opcoesMotivos}
                    </select>
                    <label>Observação</label>
                    <textarea
                        disabled={props.processando}
                        name="Observacao"
                        maxLength={100}
                        value={(formik.values?.Observacao) ?? ""}
                        onChange={(e) => {
                            formik.setFieldValue("Observacao", e.target.value);
                        }}
                        id="RegistrarPerdaCotacao_Observacao"
                    />
                </div>
            </div>

            <button 
                className={clsx(estilosBotoes.botaoPrimario)} 
                type="button" 
                id="RegistrarPerdaCotacao_BotaoRegistrar"
                disabled={props.processando}
                onClick={() => props.onRegistrar(formik.values,props.manterItem)}>
                    Registrar
            </button>

            {props?.cotacoesPerdidasPorOrcamento?.PerdaCotacao?.length > 0 &&
            <div className={estilosTabela.containerRolavel}
                style={{ marginTop: "20px", marginRight: "10px" }}
            >
            <div className={`_table _w-full _border-collapse ${estiloRegistrarPerdaCotacao.tabelaPerdaCotacao}`}
                id="RegistrarPerdaCotacao_TabelaPerdaCotacao"
            >
                <div className="_table-header-group ">
                    <div className="_table-row">
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}>
                            Data
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}
                            style={{ textAlign: "right" }}
                        >
                            Quantidade
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}>
                            Produto
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}
                            style={{ textAlign: "right" }}
                        >
                            Preço Venda
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}
                            style={{ textAlign: "right" }}
                        >
                            Preço Concorrente
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}>
                            Concorrente
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}>
                            Motivo
                        </div>
                        <div className={`_table-cell _font-bold ${estiloRegistrarPerdaCotacao.tableCellHeader}`}>
                            Observação
                        </div>
                    </div>
                </div>
                <div className="_table-row-group">
                    {linhasCotacoesPerdidas}
                </div>
                </div>
            </div>
            }
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
})